import { useEffect } from 'react';
import { useRootDispatch, useRootSelector } from '../../../../../store/hooks';
import {
  fetchSitePricingPackages,
  selectSitePricingPackagesStatus,
  selectSitePricingPackagesStatusCode,
} from '../../../store/features/packages';
import { useBasketCookie } from '../useBasketCookie';

export default function useCheckBasket() {
  const dispatch = useRootDispatch();
  const packagesStatus = useRootSelector(selectSitePricingPackagesStatus);
  const packagesStatusCode = useRootSelector(
    selectSitePricingPackagesStatusCode,
  );

  const { removeBasketIdCookie, removeOrderIdCookie, basketCreated, basketId } =
    useBasketCookie();

  useEffect(() => {
    if (packagesStatus !== 'fulfilled' && basketCreated) {
      dispatch(fetchSitePricingPackages({ basketId }));
    }
  }, []); // eslint-disable-line

  useEffect(() => {
    if (packagesStatusCode === 410) {
      removeBasketIdCookie();
      removeOrderIdCookie();
    }
  }, [packagesStatusCode, removeBasketIdCookie, removeOrderIdCookie]);
}
